<template>
  <div>
    <drawer :app="app" />

    <v-container class="mt-1">
      <v-card raised>
        <v-card-title v-if="a != null">
          <div>{{ a.FirstName }} {{ a.LastName }} - {{$t('labels.PropertiesOwned')}}</div>
        </v-card-title>

        <div style="margin: 1px 5px 5px 15px;">
          <div class="px-3" v-if="a != null">
            <v-row
              ><v-col><p v-html="$t('labels.PropertiesOwnedDesc')">
                
                </p></v-col
            ></v-row>

            <v-row>
              <v-col cols="12" v-if="a && a.Properties.length > 0">
                <v-simple-table v-if="a">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">{{$t('labels.Property')}}</th>
                        <th class="text-right" width="150">
                          <span> </span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in a.Properties" :key="item.PropertyID">
                        <td>{{ item.Address.FullAddressWithoutUnit }}</td>
                        <td class="text-right">
                          <v-btn @click="edit(item.PropertyID)" text small color="primary"><v-icon small>fas fa-edit</v-icon></v-btn>
                          <v-btn @click="del(item.PropertyID)" text small color="red"><v-icon small>fas fa-trash-alt</v-icon></v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
              <v-col cols="12" v-else> </v-col>
            </v-row>
          </div>

          <v-card-actions class="mb-5 mt-10">
            <v-btn @click="back" color="grey lighten-1">{{ $t("labels.Back") }}</v-btn>
            <v-spacer />
            <v-btn @click="add" color="primary"><v-icon x-small class="mr-2">fas fa-plus</v-icon>{{$t('labels.AddProperty')}}</v-btn>
            <v-btn @click="next" color="primary">{{$t('labels.Next')}}</v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </v-container>

    <div class="loading" v-if="loadFlag">Loading&#8230;</div>

    <v-dialog v-model="dialog" persistent max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">{{$t('labels.Property')}}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <small v-html="$t('labels.RequiredFieldsDesc')" />

            <v-row dense>
              <v-col cols="12">
                <p_addr v-model="frm.Address" :easyModeFlag="true" />
              </v-col>
              <v-col cols="6" md="4">
                <p_dd menu="OccupancyType" v-model="frm.OccupancyTypeDD" :label="$t('labels.Occupancy')" />
              </v-col>
              <v-col cols="6" md="4">
                <p_dd menu="PropertyType" v-model="frm.PropertyTypeDD" :label="$t('labels.PropertyType')" />
              </v-col>
              <v-col cols="6" md="4">
                <p_money v-model="frm.PropertyValue" :label="$t('labels.EstimatedPropertyValue')" /> 
                
              </v-col>
              <v-col cols="6" md="4">
                <p_money v-model="frm.OriginalValue" :label="$t('labels.OriginalValue')" /> 
              </v-col>
              <v-col cols="6" md="4" v-if="frm.PropertyTypeDD == 2">
                <p_money v-model="frm.CondoFees" :label="$t('labels.MonthlyCondoFees')" /> 
              
              </v-col>
              <v-col cols="6" md="4">
                 <p_money v-model="frm.AnnualTaxes" :label="$t('labels.AnnualTaxesR')" /> 
                
              </v-col>
              <v-col cols="6" md="4">
                  <p_money v-model="frm.Heating" :label="$t('labels.HeatingCost')" />               
              </v-col>
              <v-col cols="6" md="4">
                <comdatey :label="$t('labels.PurchaseDate')" v-model="frm.PurchaseDate" 
                :max="new Date().toISOString().substr(0, 10)"
                />
              </v-col>

              <v-col cols="12" v-if="frm.OccupancyTypeDD == 1 || frm.OccupancyTypeDD == 2">
                <v-card outlined>
                  <v-card-text>
                    <v-row dense>
                      <v-col cols="12">
                        {{ $t("labels.CostsFeeRelatedToRentalUnit") }}
                      </v-col>
                      <v-col cols="6" md="4">
                        <p_money v-model="frm.RentalIncome" :label="$t('labels.RentalIncome')" />                        
                      </v-col>

                      <v-col cols="6" md="4">
                        <p_money v-model="frm.ExpHydro" :label="$t('labels.Hydro')" />                           
                      </v-col>

                      <v-col cols="6" md="4">
                         <p_money v-model="frm.ExpInsurance" :label="$t('labels.Insurance')" />                         
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>

              <template v-if="1 == 2">
                <div v-html="$t('labels.CostsFeeRelatedToRentalUnit')" />

                <v-col cols="6" md="4">
                  <v-text-field type="number" v-model="frm.ExpMgmt" prefix="$">
                    <template slot="label"><span v-html="$t('labels.MonthlyMgmt')"/></template>
                  </v-text-field>
                </v-col>

                <v-col cols="6" md="4">
                  <v-text-field type="number" v-model="frm.ExpRepairs" prefix="$">
                    <template slot="label"><span v-html="$t('labels.MonthlyRepairs')"/></template>
                  </v-text-field>
                </v-col>

                <v-col cols="6" md="4">
                  <v-text-field type="number" v-model="frm.ExpInterest" prefix="$">
                    <template slot="label"><span v-html="$t('labels.MonthlyInterest')"/></template>
                  </v-text-field>
                </v-col>

                <v-col cols="6" md="4">
                  <v-text-field type="number" v-model="frm.ExpOther" prefix="$">
                    <template slot="label"><span v-html="$t('labels.MonthlyOtherCost')"/></template>
                  </v-text-field>
                </v-col>
              </template>
            </v-row>

            <v-row dense>
              <v-switch color="primary" :label="$t('labels.MortgageonThisProperty')" :false-value="false" :true-value="true" v-model="hasMortgage" />
            </v-row>

            <template v-if="hasMortgage"> 
              <v-card v-for="(mtg, idx) in frm.Mortgages" v-bind:key="mtg.MortgageID" outlined class="mb-3">
                <v-card-title>
                  Mortgage {{ idx + 1 }}
                  <v-spacer />
                  <a link @click="deleteMortgage(mtg.MortgageID)">
                    <v-icon color="red">fas fa-trash-alt</v-icon>
                  </a>
                </v-card-title>
                <v-card-text>
                  <v-row dense>
                    <v-col cols="6" md="4">
                        <p_money v-model="mtg.PAndIPayment" :label="$t('labels.MortgagePayment')" />    
                    
                    </v-col>

                    <v-col cols="6" md="4">
                      <p_dd menu="PaymentFrequency" v-model="mtg.PaymentFrequencyDD" :label="$t('labels.PaymentFrequency')" />
                    </v-col>

                    <v-col cols="6" md="4">
                       <p_money v-model="mtg.Balance" :label="$t('labels.RemainingBalance')" /> 
                      
                    </v-col>
                    <v-col cols="6" md="4">
                      <comdatey :label="$t('labels.MaturityDate')" v-model="mtg.MaturityDate" 
                      :max="date30Years"
                      />
                    </v-col>
                    <v-col cols="6" md="4">
                      <v-text-field v-model="mtg.MortgageHolder" :label="$t('labels.Lender')" />
                    </v-col>
                    <v-col cols="6" md="4">
                      <p_dd menu="TermType" v-model="mtg.TermTypeDD" :label="$t('labels.TermType')" />
                    </v-col>
                    <v-col cols="6" md="4">
                      <p_dd menu="InterestType" v-model="mtg.RateTypeDD" :label="$t('labels.InterestRateType')" />
                    </v-col>

                    <v-col cols="6" md="4">
                      <v-text-field type="number" suffix="%" v-model="mtg.InterestRate">
                        <template slot="label">
                          <span v-html="$t('labels.InterestRate')" />
                        </template>
                      </v-text-field>
                    </v-col>

                    <v-col cols="6" md="4">
                      <p_dd menu="LoanType" v-model="mtg.LoanTypeDD" :label="$t('labels.LoanType')" />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <v-row>
                <v-col cols="12" class="mt-3">
                  <v-btn :disabled="frm.Mortgages.length >= 3" color="primary" @click="addMortgage">{{ $t("labels.AddMortgage") }}</v-btn>
                </v-col>
              </v-row>
            </template>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogClose">{{$t('labels.Close')}}</v-btn>
          <v-btn color="blue darken-1" text @click="dialogSave">{{$t('labels.Save')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import drawer from "@/pages/app/agent/user/app/drawerInviteApplicant";
import dataSvc from "@/services/dataService";
import localStorageSvc from "@/services/localStorage";
import model from "@/shared/dataModels/app";
import p_dd from "@/shared/components/ddSelect";
import comdatey from "@/shared/components/datePickerY";
import p_addr from "@/shared/components/addr";
import p_money from "@/shared/components/money";

export default {
  components: {
    drawer,
    comdatey,
    p_dd,
    p_addr,p_money
  },
  data() {
    return {      
      hasMortgage: false,
      frm: model.propertyModel(),
      incomeTypes: [],
      dialog: false,
      loadFlag: false,
      app: model.appModel(),
      a: null,
      applicantID: this.$route.params.applicantid,
      mortgageApplicationID: this.$route.params.appid,
      siteID: this.$route.params.siteid,
      userID: null,
      drawerFlag: false,
      guid: this.$route.params.guid
    };
  },
  methods: {
    deleteMortgage(mortgageID) {
      this.$confirm(
        this.$t("labels.Warning"),
        this.$t("labels.ConfirmDeleteMortgage"),
        () => {
          if (mortgageID <= 0) {
            this.removeMortgage(mortgageID);
          } else {
            let postData = {
              SiteID: this.siteID,
              UserID: this.userID,
              MortgageApplicationID: this.mortgageApplicationID,
              ApplicantID: this.a.ApplicantID,
              MortgageID: mortgageID
            };
            this.loadFlag = true;
            dataSvc
              .getHttp()
              .post("/api/MTGAPPDeleteMortgageInvite", postData)
              .then(res => {
                this.loadFlag = false;
                this.removeMortgage(mortgageID);
              });
          }
        },
        () => {}
      );
    },
    removeMortgage(mortgageID) {
      this.frm.Mortgages = this.frm.Mortgages.filter(item => item.MortgageID != mortgageID);
    },
    addMortgage() {
      let m = model.mortgageModel();
      m.MortgageID = 0 - this.frm.Mortgages.length;
      this.frm.Mortgages.push(m);
    },
    dialogClose() {
      this.dialog = false;
    },
    dialogSave() {
      if (!this.dialogValid()) return;

      this.loadFlag = true;
      let postData = {
        SiteID: this.siteID,
        UserID: this.userID,
        MortgageApplicationID: this.mortgageApplicationID,
        Property: this.frm,
        ApplicantID: this.a.ApplicantID
      };
      dataSvc
        .getHttp()
        .post("/api/MTGAPPUpsertPropertyInvite", postData)
        .then(res => {
          this.loadFlag = false;
          if (res.data.ReturnStatus.ReturnCode == 200) this.loadPage();
        });

      this.dialog = false;
    },

    dialogValid() {
      let pro = this.frm;
      if (!pro.Address.StreetName) {
        this.$alert(this.$t("labels.Warning"), this.$t("errors.PropertyMissingAddress"));
        return false;
      }
      if (pro.OccupancyTypeDD === null) {
        this.$alert(this.$t("labels.Warning"), this.$t("errors.PropertyMissingOccupancyType"));
        return false;
      }
      if (pro.PropertyTypeDD == null) {
        this.$alert(this.$t("labels.Warning"), this.$t("errors.PropertyMissingPropertyType"));
        return false;
      }
      if (pro.PropertyValue <= 0) {
        this.$alert(this.$t("labels.Warning"), this.$t("errors.PropertyMissingPropertyValue"));
        return false;
      }
      if (pro.AnnualTaxes <= 0) {
        this.$alert(this.$t("labels.Warning"), this.$t("errors.PropertyMissingPropertyTax"));
        return false;
      }

      if (pro.OccupancyTypeDD == 2 || pro.OccupancyTypeDD == 1) {
        if (pro.RentalIncome <= 0) {
          this.$alert(this.$t("labels.Warning"), this.$t("errors.PropertyMissingRentalIncome"));
          return false;
        }
      }

      if (pro.PropertyTypeDD == 2) {
        if (pro.CondoFees <= 0) {
          this.$alert(this.$t("labels.Warning"), this.$t("errors.PropertyMissingCondoFee"));
          return false;
        }
      }

    if( this.hasMortgage){
      for (let i = 0; i < pro.Mortgages.length; i++) {
        let mtg = pro.Mortgages[i];
        if (mtg.PaymentFrequencyDD == null) {
          this.$alert(this.$t("labels.Warning"), this.$t("errors.PropertyMissingPaymentFrequency"));
          return false;
        }
        if (mtg.Balance <= 0) {
          this.$alert(this.$t("labels.Warning"), this.$t("errors.PropertyMissingBalance"));
          return false;
        }

        if (mtg.RateTypeDD == null) {
          this.$alert(this.$t("labels.Warning"), this.$t("errors.PropertyMissingRateType"));
          return false;
        }
        if (mtg.InterestRate == null) {
          this.$alert(this.$t("labels.Warning"), this.$t("errors.PropertyMissingInterestRate"));
          return false;
        }
        if (mtg.LoanTypeDD == null) {
          this.$alert(this.$t("labels.Warning"), this.$t("errors.PropertyMissingLoanType"));
          return false;
        }
        if(mtg.MaturityDate == null){
          this.$alert(this.$t("labels.Warning"), this.$t("errors.PropertyMissingMaturityDate"));
          return false;
        }
      }
    } else {
      pro.Mortgages = [];
    }

      return true;
    },
    loadPage() {
      this.loadFlag = true;
      let postData = {
        SiteID: this.siteID,
        ApplicantID: this.applicantID,
        MortgageApplicationID: this.mortgageApplicationID,
        guid: this.guid
      };
      dataSvc
        .getHttp()
        .post("/api/MTGAPPLoadInvite", postData)
        .then(res => {
          this.loadFlag = false;
          if (res.data.ReturnStatus.ReturnCode == 200) {
            this.app = res.data;

            for (let i = 0; i < this.app.Applicants.length; i++) {
              if (this.app.Applicants[i].ApplicantID == res.data.CurrentApplicantID) {
                this.a = this.app.Applicants[i];
              }
            }
          }else{
            this.loadFlag = false;
             this.$alert(this.$t('labels.Warning'), this.$t('errors.InviteCoApplicantSubmitted'));
              setTimeout(()=>{
              window.location = '/' + this.siteID ;
              }, 5000);
          }
          this.app.UserID = this.userID;
          this.app.SiteID = this.siteID;
        });
    },
    back() {
      // this.$router.push("/" + this.siteID + "/InviteCoApplicant/" + this.mortgageApplicationID + "/applicant/" + this.applicantID + "/income");
       if(this.app.showIncome == true){
              this.$router.push("/" + this.siteID + "/InviteCoApplicant/" + this.mortgageApplicationID + '/' + this.guid + "/applicant/" + this.applicantID + "/income");
          }else{
             this.$router.push("/" + this.siteID + "/InviteCoApplicant/" + this.mortgageApplicationID + '/' + this.guid + "/applicant/" + this.applicantID + "/address");
          }
    },
    add() {
      // clear
      this.frm = model.propertyModel();
      this.hasMortgage = false;
      this.dialog = true;
    },
    del(propertyID) {
      this.$confirm(
        this.$t("labels.Warning"),
        this.$t("labels.ConfirmDeleteProperty"),
        () => {
          let postData = {
            SiteID: this.siteID,
            UserID: this.userID,
            MortgageApplicationID: this.mortgageApplicationID,
            ApplicantID: this.a.ApplicantID,
            PropertyID: propertyID
          };
          this.loadFlag = true;
          dataSvc
            .getHttp()
            .post("/api/MTGAPPDeletePropertyInvite", postData)
            .then(res => {
              this.loadFlag = false;
              this.loadPage();
            });
        },
        () => {}
      );
    },
    setValue() {
      let purchaseDate = this.frm.strPurchaseDate;
      setTimeout(() => {
        this.frm.PurchaseDate = "2019-1-1";
        setTimeout(() => {
          this.frm.PurchaseDate = this.frm.strPurchaseDate;
        }, 300);
      }, 300);

      for (let i = 0; i < this.frm.Mortgages.length; i++) {
        setTimeout(() => {
          this.frm.Mortgages[i].MaturityDate = "2019-1-1";
          setTimeout(() => {
            this.frm.Mortgages[i].MaturityDate = this.frm.Mortgages[i].strMaturityDate;
          }, 300);
        }, 300);
      }
    },
    edit(propertyID) {
      let postData = {
        SiteID: this.siteID,
        UserID: this.userID,
        MortgageApplicationID: this.mortgageApplicationID,
        ApplicantID: this.a.ApplicantID,
        PropertyID: propertyID
      };
      this.loadFlag = true;
      dataSvc
        .getHttp()
        .post("/api/MTGAPPLoadPropertyInvite", postData)
        .then(res => {
          this.frm = res.data.Property;
          this.setValue();

          if (this.frm.Mortgages.length > 0) this.hasMortgage = true;

          this.loadFlag = false;
          this.dialog = true;
        });
    },
    next() {
      let postData = {
        SiteID: this.siteID,
        UserID: this.userID,
        MortgageApplicationID: this.mortgageApplicationID,
        ApplicantID: this.a.ApplicantID
      };
      this.loadFlag = true;
      dataSvc
        .getHttp()
        .post("/api/MTGAPPDonePropertyInvite", postData)
        .then(res => {
          this.loadFlag = false;
         // this.$router.push("/" + this.siteID + "/InviteCoApplicant/" + this.mortgageApplicationID + "/applicant/" + this.applicantID + "/asset");
          if(this.app.showAssets == true){
             this.$router.push("/" + this.siteID + "/InviteCoApplicant/" + this.mortgageApplicationID + '/' + this.guid + "/applicant/" + this.applicantID + "/asset");
          }else{
            this.$router.push("/" + this.siteID + "/InviteCoApplicant/" + this.mortgageApplicationID + '/' + this.guid + "/applicant/summary");
          }
        });
    }
  },
  created() {
    this.userID = localStorageSvc.getUser();  
    this.loadPage();
  
  },
  beforeRouteUpdate(to, from, next) {
    this.applicantID = to.params.applicantid;
    this.loadPage();
    next();
  },
  watch: {
    hasMortgage(n) {
      if (n === true) {
        if (this.frm.Mortgages.length == 0) {
          this.frm.Mortgages.push(model.mortgageModel());
        }
      }
    }
  },
  computed:{
     date30Years() {
      let n = new Date();
      n.setFullYear(n.getFullYear() + 30);
      return n.toISOString().substr(0, 10);
    }
  }
};
</script>

<style></style>
